import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import DefaultIsMobileContext from './DefaultIsMobileContext.js';
import useIsMatchingMediaQuery from './useIsMatchingMediaQuery.js';
const useIsMobile = mobileBreakpoint => {
  const initialValue = useContext(DefaultIsMobileContext);
  const theme = useContext(ThemeContext);
  const breakpoints = theme?.breakpoints || {};
  const query = `(max-width: ${mobileBreakpoint || breakpoints.tablet}px)`;
  return useIsMatchingMediaQuery({
    query,
    initialValue
  });
};
export { useIsMobile as default };
//# sourceMappingURL=useIsMobile.js.map
